// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bep_a bhp_bj"};